import zhcn from "./zhcn";
import en from "./en";
import jp from "./jp";

export default {
   zhcn, en, jp
}
